export interface IJobRequestMap {
  shouldScheduleJob: boolean
  jobRequestData: any
}

class JobRequestMap implements IJobRequestMap {
  shouldScheduleJob: boolean
  jobRequestData: any

  constructor(jobRequestMap?: any) {
    this.shouldScheduleJob = jobRequestMap?.shouldScheduleJob || false
    this.jobRequestData = jobRequestMap?.jobRequestData || {}
  }
}

export default JobRequestMap
